// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1uqEq","actionsCol":"EnrolledClinics_actionsCol__DTplZ"};